/*
  mf-tiktok.js — pixel do TikTok (Events API via ttq), consentimento-first.

  Regras que este arquivo NAO quebra (mesmo espirito do mf-analytics.js):
  1. O pixel (ttq.load) so e criado depois do consentimento de MARKETING
     (window.mfConsent.marketing) — igual ao loadGA4() do lgpd-cookies:
     nada de cookie/pixel de terceiro antes do aceite.
  2. Zero dado pessoal nos eventos. Mesmo catalogo do mf-analytics.js
     (window.MF_DATA): id/sku, nome, marca, categoria, preco, quantidade.
  3. content_id = SKU da variante — mesmo offerId do feed do Merchant Center,
     pra bater com o catalogo do TikTok Shopping/Catalog se um dia existir.
  4. InitiateCheckout e best-effort (o checkout e um host externo — Adoorei —
     e so vemos o clique que leva pra la, nao o resultado). CompletePayment
     NAO sai daqui: precisa do Events API server-side no gateway, fora do
     escopo deste arquivo (mesma pendencia que o GA4 ja tem documentada).
*/
(function () {
  'use strict';

  var PIXEL_ID = window.MF_TIKTOK_ID || null;
  if (!PIXEL_ID) { return; }

  var D = window.MF_DATA || {};
  var MOEDA = D.moeda || 'BRL';
  var pixelCarregado = false;
  var fila = [];
  var LIMITE = 40;
  var jaMandou = {};

  function consentiu() {
    return !!(window.mfConsent && window.mfConsent.marketing);
  }

  /* --------------------------------------------------------- carregar ttq */

  function carregarPixel() {
    if (pixelCarregado || !PIXEL_ID) { return; }
    pixelCarregado = true;

    !function (w, d, t) {
      w.TiktokAnalyticsObject = t;
      var ttq = w[t] = w[t] || [];
      ttq.methods = ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group", "enableCookie", "disableCookie", "holdConsent", "revokeConsent", "grantConsent"];
      ttq.setAndDefer = function (t, e) { t[e] = function () { t.push([e].concat(Array.prototype.slice.call(arguments, 0))); }; };
      for (var i = 0; i < ttq.methods.length; i++) { ttq.setAndDefer(ttq, ttq.methods[i]); }
      ttq.instance = function (t) {
        var e = ttq._i[t] || [];
        for (var n = 0; n < ttq.methods.length; n++) { ttq.setAndDefer(e, ttq.methods[n]); }
        return e;
      };
      ttq.load = function (e, n) {
        var r = "https://analytics.tiktok.com/i18n/pixel/events.js", o = n && n.partner;
        ttq._i = ttq._i || {}; ttq._i[e] = []; ttq._i[e]._u = r;
        ttq._t = ttq._t || {}; ttq._t[e] = +new Date();
        ttq._o = ttq._o || {}; ttq._o[e] = n || {};
        var scr = document.createElement("script");
        scr.type = "text/javascript"; scr.async = true; scr.src = r + "?sdkid=" + e + "&lib=" + t;
        var first = document.getElementsByTagName("script")[0];
        first.parentNode.insertBefore(scr, first);
      };
      ttq.load(PIXEL_ID);
      ttq.page();
    }(window, document, 'ttq');

    // esvazia o que ficou em espera enquanto o pixel nao existia
    var pendentes = fila.slice();
    fila.length = 0;
    for (var i = 0; i < pendentes.length; i++) {
      window.ttq.track(pendentes[i][0], pendentes[i][1]);
    }
  }

  function manda(nome, params) {
    if (!consentiu()) {
      if (fila.length < LIMITE) { fila.push([nome, params]); }
      return;
    }
    if (!pixelCarregado) { carregarPixel(); }
    if (window.ttq && typeof window.ttq.track === 'function') {
      window.ttq.track(nome, params);
    }
  }

  function umaVezPorPagina(chave) {
    if (jaMandou[chave]) { return false; }
    jaMandou[chave] = true;
    return true;
  }

  document.addEventListener('lgpd:consent', function (e) {
    var c = e && e.detail;
    if (c && c.marketing) { carregarPixel(); }
    else { fila.length = 0; }
  });

  if (consentiu()) { carregarPixel(); }

  /* ------------------------------------------------------------- itens */

  function contentDaVariante(v) {
    if (!v) { return null; }
    return {
      content_id: v.sku || ('shopify_' + v.id),
      content_name: v.nome,
      content_category: v.categoria || undefined,
      price: typeof v.preco === 'number' ? v.preco : undefined,
      currency: MOEDA,
      brand: v.marca || undefined
    };
  }

  /* ------------------------------------------------------------ eventos */

  // ViewContent — pagina de produto
  if (D.produto && umaVezPorPagina('ViewContent')) {
    var content = contentDaVariante(D.produto);
    if (content) {
      manda('ViewContent', {
        content_type: 'product',
        contents: [content],
        value: content.price,
        currency: MOEDA
      });
    }
  }

  // AddToCart — mesmo par de caminhos do mf-analytics.js (evento do tema + submit nativo),
  // deduplicados por variante numa janela de 2s.
  var ultimoAdd = { id: null, t: 0 };
  function jaContou(id) {
    var agora = new Date().getTime();
    if (ultimoAdd.id === id && agora - ultimoAdd.t < 2000) { return true; }
    ultimoAdd = { id: id, t: agora };
    return false;
  }

  function mandaAddToCart(v, qtd) {
    var content = contentDaVariante(v);
    if (!content || jaContou(content.content_id)) { return; }
    var q = qtd || 1;
    manda('AddToCart', {
      content_type: 'product',
      contents: [content],
      value: typeof content.price === 'number' ? Math.round(content.price * q * 100) / 100 : undefined,
      currency: MOEDA,
      quantity: q
    });
  }

  document.addEventListener('product:added', function (e) {
    var det = (e && e.detail) || {};
    var qtd = parseInt(det.quantity, 10) || 1;
    var v = null;

    if (det.variant && det.variant.id && D.porVariante) {
      v = D.porVariante[String(det.variant.id)];
    }
    if (!v) {
      var form = e.target && e.target.closest ? e.target.closest('form[action*="/cart/add"]') : null;
      var campo = form ? form.querySelector('[name="id"]') : null;
      if (campo && D.porVariante) { v = D.porVariante[String(campo.value)]; }
    }
    if (!v && D.produto) { v = D.produto; }
    mandaAddToCart(v, qtd);
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) { return; }
    var campoId = form.querySelector('[name="id"]');
    var campoQtd = form.querySelector('[name="quantity"]');
    var v = (campoId && D.porVariante) ? D.porVariante[String(campoId.value)] : null;
    if (!v) { v = D.produto; }
    mandaAddToCart(v, campoQtd ? (parseInt(campoQtd.value, 10) || 1) : 1);
  }, true);

  document.addEventListener('variant:changed', function (e) {
    var det = (e && e.detail) || {};
    if (det.variant && det.variant.id && D.porVariante && D.porVariante[String(det.variant.id)]) {
      D.produto = D.porVariante[String(det.variant.id)];
    }
  }, true);

  // InitiateCheckout — best-effort: dispara no clique do botao que o ChtCheckout
  // (snippets/ChtCheckout.liquid) cria com a classe fixa 'cht_elem_mainBtn' antes de
  // redirecionar pro host externo (seguro.modafemininaoficial.shop). Nao intercepta nem
  // atrasa a navegacao — so observa o clique.
  document.addEventListener('click', function (e) {
    var el = e.target.closest ? e.target.closest('.cht_elem_mainBtn, .cht-btn-finalize-single') : null;
    if (!el || !umaVezPorPagina('InitiateCheckout')) { return; }
    var itens = [];
    var valor = 0;
    if (D.carrinho && D.carrinho.itens && D.carrinho.itens.length) {
      for (var i = 0; i < D.carrinho.itens.length; i++) {
        var c = contentDaVariante(D.carrinho.itens[i]);
        if (!c) { continue; }
        var q = D.carrinho.itens[i].quantidade || 1;
        itens.push(c);
        if (typeof c.price === 'number') { valor += c.price * q; }
      }
    }
    manda('InitiateCheckout', {
      content_type: 'product',
      contents: itens.length ? itens : undefined,
      value: itens.length ? Math.round(valor * 100) / 100 : undefined,
      currency: MOEDA
    });
  }, true);
})();
